import type { ReactNode } from "react";
import type { GridProps } from "@mui/material";
import { Typography, Stack, Checkbox, Grid } from "@mui/material";
import type { Commune } from "models";

interface RecapitulatifDeselectionnableCommuneProps extends GridProps {
  communes?: Array<Partial<Commune>>;
  onCommuneChange: (communes: Array<Commune>) => void;
}

export function RecapitulatifDeselectionnableCommune({
  communes,
  onCommuneChange: onChange,
  ...gridProps
}: Readonly<RecapitulatifDeselectionnableCommuneProps>): ReactNode {
  if (communes == null || communes.length === 0) return null;

  return (
    <Grid container size={12} spacing={2} {...gridProps}>
      <Typography component={Grid} size={12}>
        Récapitulatif des communes sélectionnées :
        <br />
        <Typography component="span" variant="caption" color="text.secondary">
          Cliquez sur une commune pour la retirer de la sélection
        </Typography>
      </Typography>

      <Stack spacing={0}>
        {communes?.map((c) => (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            key={c.id}
            onClick={() => {
              onChange(((communes ?? []) as Array<Commune>).filter((com) => com.id !== c.id));
            }}
            sx={{ cursor: "pointer" }}>
            <Checkbox checked size="small" sx={{ p: 0.5 }} />
            <Typography>
              {c.libelle} <span className="grey">({c.id?.substring(0, 2)})</span>
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Grid>
  );
}
